import { useState } from 'react';
import Image, { ImageProps } from 'next/image';

interface CustomImageProps extends ImageProps {
    src:string;
    fallbackSrc:string;
    alt:string;
}
const CustomImage = ({ src, fallbackSrc, alt, ...props }:CustomImageProps) => {
  const [imgSrc, setImgSrc] = useState(src);

  return (
    <Image
      {...props}
      src={imgSrc}
      alt={alt}
      onError={() => setImgSrc(fallbackSrc)}
    />
  );
};

export default CustomImage;
